import { render, staticRenderFns } from "./rejustReason.vue?vue&type=template&id=3b65780a&scoped=true"
import script from "./rejustReason.vue?vue&type=script&lang=js"
export * from "./rejustReason.vue?vue&type=script&lang=js"
import style0 from "./rejustReason.vue?vue&type=style&index=0&id=3b65780a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b65780a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b65780a')) {
      api.createRecord('3b65780a', component.options)
    } else {
      api.reload('3b65780a', component.options)
    }
    module.hot.accept("./rejustReason.vue?vue&type=template&id=3b65780a&scoped=true", function () {
      api.rerender('3b65780a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliancecso/metricsManager/dialog/rejustReason.vue"
export default component.exports